import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable, catchError, map, of, timeout } from 'rxjs';
import { ApiResponse } from '../models/api-response.model';
import { PendingAcceptances } from '../models/pending-acceptances.model';
import { SKIP_ERROR_TOAST } from '../interceptors/error.interceptor';

const PENDING_ACCEPTANCES_ENDPOINT = '/api/v1/auth/external/pending-acceptances';
const REQUEST_TIMEOUT_MS = 15000;

@Injectable({ providedIn: 'root' })
export class LegalAcceptanceService {
  private readonly http = inject(HttpClient);

  getBlockingAcceptances(): Observable<PendingAcceptances | null> {
    return this.http
      .get<ApiResponse<PendingAcceptances | null>>(PENDING_ACCEPTANCES_ENDPOINT, {
        context: new HttpContext().set(SKIP_ERROR_TOAST, true),
      })
      .pipe(
        timeout(REQUEST_TIMEOUT_MS),
        map((response) => (response?.state && response.data?.isBlocked === true ? response.data : null)),
        catchError((error) => {
          console.warn('No se pudo verificar los documentos pendientes; se permite el ingreso:', error);
          return of(null);
        }),
      );
  }
}
